import { IProductConfigOption } from "@montana/models/dev";
import { transformFeatures } from "./cylindo.helper";

// export function transformFeaturesLD(dimensions: IProductConfigOption[]) {
//     return dimensions
//         .map((dimension: IProductConfigOption) => {
//             return {
//                 name: dimension.seoFriendlyDimensionName || dimension.dimensionName,
//                 value: dimension.seoFriendlyDisplayValue || dimension?.displayValue?.replace(/\s+/g , "-")
//             }
//         }).reduce((acc: {[key: string]: any}, feature) => {
//             if (feature.value !== undefined && feature.name !== undefined) {
//                 acc[feature.name] = feature.value;
//             }
//             return acc;
//         }, {});
// }
export function transformFeaturesLD(dimensions: IProductConfigOption[]) {
    const featureArray: string[] = transformFeatures(dimensions);
    const keyValuePairs = {};
    for (let i = 0; i < featureArray.length; i = i + 2) {
        if (Boolean(featureArray[i]) !== false) {
            Object.assign(keyValuePairs, {
                [featureArray[i].toUpperCase()]: featureArray[
                    i + 1
                ].toUpperCase()
            });
        }
        // Object.assign(keyValuePairs, {[featureArray[i].replace(/\s+/g , "_")]: featureArray[i+1].replace(/\s+/g , "_")});
    }

    return keyValuePairs;
}

export function validateFeaturesLD(oldFeatureConfig: {}, newFeatureConfig: {}) {
    const updatedFeatureConfig: { [key: string]: any } = {
        ...newFeatureConfig
    };
    const keysOld = Object.keys(oldFeatureConfig);
    const keysNew = Object.keys(newFeatureConfig);

    for (const key of keysOld) {
        if (!keysNew.includes(key)) {
            updatedFeatureConfig[key] = "!!none";
        }
    }

    return updatedFeatureConfig;
}

export function compareFeatureConfig(object1: {}, object2: {}) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (
            object1[key as keyof typeof object1] !==
            object2[key as keyof typeof object2]
        ) {
            return false;
        }
    }

    return true;
}

/**
 * Helper function for setting desired frame on london dynamic image url
 * @param imgUrl url to manipulate for proper URL
 * @param frame number value of desire frame (Must be between 1-32) 1 = 0 deg,
 */
export function transformLondonDynamicsImageFrame(
    imgUrl: string,
    frame: number
) {
    const hasFrame = /(frames\/)[^/]+/g.test(imgUrl);
    if (hasFrame) {
        return imgUrl.replace(/(frames\/)[^/]+/g, `frames/${frame}`);
    }
    return imgUrl;
}

/**
 * Helper function for setting desired frame on london dynamic image url
 * @param imgUrl url to manipulate for proper URL
 * @param frame number value of desire frame (Must be between 1-32) 1 = 0 deg,
 */
export function transformLDImageFrame(imgUrl: string, frame: number) {
    return imgUrl.replace(/\/[^/]+\.jpg/, `/${frame}.jpg`);
}

/**
 * Helper function for setting desired background color on london dynamic image url
 * @param imgUrl url to manipulate for proper URL
 * @param backgroundColor hex value of desired color without hashtag --> example: 'FAFAFA'
 */
export function transformLDImageBackground(
    imgUrl: string,
    backgroundColor: string
) {
    const regex = /(bgcolour=)[^&]+/g;
    const param = "bgcolour=";

    const hasBackground = regex.test(imgUrl);

    // Clean # from backgroundColor if hex value
    const cleanBackgroundHex = backgroundColor.replace("#", "");

    if (hasBackground) {
        return imgUrl.replace(regex, `${param + cleanBackgroundHex}`);
    } else {
        return /\?.+=.*/.test(imgUrl)
            ? `${imgUrl}&${param + cleanBackgroundHex}`
            : `${imgUrl}?${param + cleanBackgroundHex}`;
    }
}

/**
 * Helper function for setting desired pixel size on CAPI url
 * @param imgUrl url to manipulate for proper URL
 * @param number desired pixel size of image.
 */
export function transformLDImageSize(
    imgUrl: string,
    width: number,
    ratio?: number
) {
    const hasSize = /(height=)[^&]+/g.test(imgUrl);
    const sizeString = !!ratio
        ? `height=${width}&width=${Math.round(ratio * width)}`
        : `height=${width}`;
    if (hasSize) {
        return imgUrl.replace(/(height=)[^&]+/g, sizeString);
    } else {
        return /\?.+=.*/.test(imgUrl)
            ? `${imgUrl}&${sizeString}`
            : `${imgUrl}?${sizeString}`;
    }
}
